var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"app-footer"},[_vm._v("\n    "+_vm._s(_vm.$t('footer.footer'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }